/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import {
  updateCMSTableDetail,
  viewHistoryPlans,
  addNewRowData,
  setCMSExtraState,
  cmsTableError,
  getCmsMatDrugsList,
  setCMSEditedData,
  resetMatDrugStore,
  setNewCmsMatRowData,
  handleErrorMessages,
  dispatchGetCMSTableEditedData,
} from '../store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { SAVE_SUCCESS } from '../../../../SharedModules/AppConstants';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import {
  BOTH_CODE_ERR,
  CANNOT_DEL,
  DUP_CODE,
  GENERIC_ERR,
  QUARTER_FORMAT_ERROR,
  SPEC_OR_GEN_CODE_REQUIRED,
  STRT_QTR_GREATER_THAN_3_ERR,
  STRT_QTR_REQUIRED_ERR
} from './constantData';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { cmsTableHead } from './gridComponents/tableHead';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  checkQuarterValidation,
  closeTab,
  convertQuatreManufacturer,
  handleScrollToEvent,
  compareQtrs
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {END_QTR_GRATER_START_QTR_ERR } from '../../../../SharedModules/Errors/constantMessageData';
import TextBoxRender from './gridComponents/TextBoxRender';
import CmsFrameworks from './gridComponents/cmsFrameworks';
import {
  tabHighLigther,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';

// above line imported avoide the colums swipe issues
function MatDrug(props) {
  const dispatch = useDispatch();
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [gridApi, setGridApi] = useState(gridRef);
  const searchCmsMatDrugList = (value) => dispatch(getCmsMatDrugsList());
  const updateCMSDetail = (value) => dispatch(updateCMSTableDetail(value));
  const setEditedData = (value) => dispatch(setCMSEditedData(value));
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [filterRest, setFilterRest] = useState(false);
  const [willClostTab, setWillClostTab] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [fullScreenView, setFullScreenView] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(
      process.env.REACT_APP_REPORT_ROLE,
      kcRoles
    )
  );
  const data = useSelector(
    (state) => state.sharedState.CmsReducer.rebateCMSSearchResult
  );
  let viewHistoryListData = useSelector(
    (state) => state.sharedState.CmsReducer.planViewHistory
  );
  const cmsErrorMsg = useSelector(
    (state) => state.sharedState.CmsReducer.errorField
  );
  const editedData = useSelector(
    (state) => state.sharedState.CmsReducer.editedData
  );
  const extraState = useSelector(
    (state) => state.sharedState.CmsReducer.extraState
  );
  const edit = useSelector(
    (state) => state.sharedState.CmsReducer.extraState.edit
  );
  const resultData = useSelector(
    (state) => state.sharedState.CmsReducer.matDrugListFromStore
  );
  const successRes = useSelector(
    (state) => state.sharedState.CmsReducer.successRes
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.CmsReducer?.errorMessagesInRedux;
  });
  const setState = (value) => dispatch(setCMSExtraState(value));

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);
  const childRef = useRef(null);
  const [add, setAdd] = useState(false);
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  const handleError = (key, value) => {
    const errorMsg = {
      ...cmsErrorMsg,
      [key]: value,
    };
    dispatch(cmsTableError(errorMsg));
  };

  const setStateChange = (key, val) => {
    setState({
      ...extraState,
      [key]: val,
    });
  };
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(
          process.env.REACT_APP_REPORT_ROLE,
          kcRoles
        )
      );
    }
  }, []);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  useEffect(() => {
    if (successRes && successRes.data.message === 'SUCESS') {
      handleScrollToEvent();
      setEditedData([]);
      setSuccessMessages([SAVE_SUCCESS]);
      dispatch(cmsTableError([]));
      if (willClostTab) {
        dispatch(resetMatDrugStore());
        closeTab('/MaintainCMSMatDrugs', props.history, dispatch);
      }
    }
  }, [successRes]);

  useEffect(() => {
    viewHistoryListData = [];
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => {
        return x.navTo === '/MaintainCMSMatDrugs' && x.isRefresh;
      }).length > 0
    ) {
      const newObj = localStore.map((item) => {
        if (item.navTo === '/MaintainCMSMatDrugs') {
          item.isRefresh = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      searchCmsMatDrugList();
    }
  }, [data]);

  // Tab highlighter POC
  useEffect(() => {
    const errMsg = cmsErrorMsg.errorMessages;
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/MaintainCMSMatDrugs' && edit) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/MaintainCMSMatDrugs') {
          if (edit && !_.isEmpty(errMsg)) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [edit, cmsErrorMsg]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/MaintainCMSMatDrugs' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/MaintainCMSMatDrugs' && item.isFormSave) {
          item.isFormSave = false;
          if (validateRequest()) {
            setWillClostTab(true);
            masterDataSave();
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/MaintainCMSMatDrugs', true);
    } else {
      tabHighLigther('/MaintainCMSMatDrugs', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  const validateRequest = (data) => {
    let localErr = [];
    const checkdata = data || resultData;
    const newObj = data ? [...data] : [...resultData];
    const editedRows = checkdata?.filter((x) => x.addEdit) || [];
    editedRows.forEach((prop) => {
      const rowIndex = newObj.findIndex((x) => x.id === prop.id);
      if (rowIndex === -1) return;
      newObj[rowIndex].genCodeNumErr = false;
      newObj[rowIndex].specTheraCodeErr = false;
      newObj[rowIndex].startQtrErr = false;
      newObj[rowIndex].endQtrErr = false;  
      const startQtrValid =
        prop.startQtr && checkQuarterValidation(prop.startQtr);
      const endQtrValid =
        !prop.endQtr || checkQuarterValidation(prop.endQtr);
  
      /* ---------- START QUARTER REQUIRED ---------- */
      if (!prop.startQtr) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push({
          fieldName: `startQtr${rowIndex}`,
          errorType: 'startQtrRequired',
          message: `${STRT_QTR_REQUIRED_ERR} #${rowIndex + 1}.`,
        });
      }
  
      /* ---------- START QUARTER FORMAT ---------- */
      if (prop.startQtr && !startQtrValid) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push({
          fieldName: `startQtr${rowIndex}`,
          errorType: 'invalidQuarterFormat',
          message: `${constantMessageData.CONTRACT_START_QUARTER_FORMAT_ERROR} #${
            rowIndex + 1
          }.`,
        });
      }
  
      /* ---------- START QUARTER >= 3Q2020 ---------- */
      if (
        startQtrValid &&
        convertQuatreManufacturer(prop.startQtr) &&
        Date.parse('07/01/2020') >
          Date.parse(convertQuatreManufacturer(prop.startQtr))
      ) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push({
          fieldName: `startQtr${rowIndex}`,
          errorType: 'startQtrGreater',
          message: `${STRT_QTR_GREATER_THAN_3_ERR} #${rowIndex + 1}.`,
        });
      }
      /* ---------- END QUARTER FORMAT ---------- */
      if (prop.endQtr && !endQtrValid) {
        newObj[rowIndex].endQtrErr = true;
        localErr.push({
          fieldName: `endQtr${rowIndex}`,
          errorType: 'invalidQuarterFormat',
          message: `${constantMessageData.CONTRACT_END_QUARTER_FORMAT_ERROR} #${
            rowIndex + 1
          }.`,
        });
      }
  
      /* ---------- END QUARTER >= START QUARTER ---------- */
      if (
        prop.startQtr &&
        prop.endQtr &&
        startQtrValid &&
        endQtrValid
      ) {
        const isInvalidRange = compareQtrs(
          prop.startQtr,
          prop.endQtr
        );
  
        if (isInvalidRange) {
          newObj[rowIndex].endQtrErr = true;
  
          localErr.push({
            fieldName: `endQtr${rowIndex}`,
            errorType: 'rangeInvalid',
            message: `${END_QTR_GRATER_START_QTR_ERR} #${rowIndex + 1}.`,
          });
        }
      }
  
      /* ---------- SPEC / GEN REQUIRED ---------- */
      if (!prop.specTheraCode && !prop.genCodeNum) {
        newObj[rowIndex].specTheraCodeErr = true;
        newObj[rowIndex].genCodeNumErr = true;
        localErr.push({
          fieldName: `specTheraCode${rowIndex}`,
          errorType: 'SPEC_OR_GEN_CODE_REQUIRED',
          message: `${SPEC_OR_GEN_CODE_REQUIRED} #${rowIndex + 1}.`,
        });
      }
      /* ---------- BOTH NOT ALLOWED ---------- */
      if (prop.specTheraCode && prop.genCodeNum) {
        newObj[rowIndex].specTheraCodeErr = true;
        newObj[rowIndex].genCodeNumErr = true;
        localErr.push({
          fieldName: `specTheraCode${rowIndex}`,
          errorType: 'BOTH_CODE_ERR',
          message: `${BOTH_CODE_ERR} #${rowIndex + 1}.`,
        });
      }
      /* ---------- DUPLICATE CHECK ---------- */
      const hasDuplicate =
        startQtrValid &&
        newObj.some((x) => {
          if (x.isRemovedFromList) return false;
          if (x.id === prop.id) return false;
          if (!x.startQtr || x.startQtr !== prop.startQtr) {
            return false;
          }
          if (prop.genCodeNum) {
            return x.genCodeNum === prop.genCodeNum;
          }
          if (prop.specTheraCode) {
            return x.specTheraCode === prop.specTheraCode;
          }
          return false;
        });
      if (hasDuplicate) {
        if (prop.genCodeNum) {
          newObj[rowIndex].genCodeNumErr = true;
        }
        if (prop.specTheraCode) {
          newObj[rowIndex].specTheraCodeErr = true;
        }
        localErr.push({
          fieldName: prop.genCodeNum
            ? `genCodeNum${rowIndex}`
            : `specTheraCode${rowIndex}`,
          errorType: 'DUP_CODE',
          message: `${DUP_CODE} #${rowIndex + 1}.`,
        });
      }
    });
    dispatch(handleErrorMessages(localErr));
    dispatch(setNewCmsMatRowData(newObj));
    handleScrollToEvent();
    return localErr.length === 0;
  };

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const masterDataSave = (e) => {
    handleSaveClose();
    setStateChange('edit', false);
    dispatch(handleErrorMessages([]));
    setSuccessMessages([]);
    if (
      resultData?.filter((x) => {
        return x.addEdit;
      })?.length > 0
    ) {
      updateCMSDetail(
        resultData
          ?.filter((x) => {
            return x.addEdit;
          })
          ?.map((item) => {
            return {
              cmsMATSeqNum: item?.cmsMATSeqNum,
              disableEndQtr: item?.disableEndQtr,
              disableGenCodeNum: item?.disableGenCodeNum,
              disableSpecTheraCode: item?.disableSpecTheraCode,
              disableStartQtr: item?.disableStartQtr,
              endQtr: item?.endQtr,
              genCodeNum: item?.genCodeNum,
              isRemovedFromList: item?.isRemovedFromList,
              rowId: item?.rowId,
              specTheraCode: item?.specTheraCode,
              startQtr: item?.startQtr,
              index: item?.index,
              lastUpdateUserId: logInUser,
            };
          })
      );
    }
  };
  // get edited data
  const onEditingStopped = useCallback(
    (e) => {
      setSuccessMessages([]);
      setStateChange('edit', true);
      if (e && e.value !== e.oldValue) {
        const obj = e.data;
        const newData = !_.isEmpty(editedData)
          ? _.filter(editedData, (l) => l.id !== e.id)
          : [];
        newData.push(obj);
        setEditedData(newData);
      }
    },
    [editedData]
  );

  const openSave = () => {
    setSuccessMessages([]);
    if (validateRequest()) {
      dispatch(handleErrorMessages([]));
      setOpen(true);
    } else {
      setOpen(false);
    }
  };
  // set save alert close
  const handleSaveClose = () => {
    setOpen(false);
  };
  // set Cancel alert open
  const cancel = () => {
    setSuccessMessages([]);
    setOpenCancel(true);
  };
  // set Cancel Alert close and reset all data
  const handleCancel = () => {
    setEditedData([]);
    dispatch(handleErrorMessages([]));
    setSuccessMessages([]);
    setFilterRest(true);
    setStateChange('edit', false);
    if (add) {
      dispatch(addNewRowData(data));
    }
    setOpenCancel(false);
  };
  // set Cancel Alert close
  const handleCancelClose = () => {
    setOpenCancel(false);
  };

  const validateDeleteDrug = (cellInfo) => {
    const qtrToDelete = { startQtr: cellInfo.data.startQtr };
    return axios
      .post(serviceEndPoint.VALIDATE_DELETE_DRUG, qtrToDelete)
      .then((response) => {
        if (response.data.status === '001') {
          cellInfo.api.applyTransaction({
            remove: [cellInfo?.node?.data],
          });
          setStateChange('edit', true);
          const rowIndex = resultData?.findIndex((x) => {
            return x.id === cellInfo?.data?.id;
          });
          const newObj = [...resultData];
          newObj[rowIndex].isRemovedFromList = true;
          newObj[rowIndex].addEdit = true;
          dispatch(setNewCmsMatRowData(newObj));
        } else if (response.data.status === '003') {
          handleError('errorMessages', [response.data.message || GENERIC_ERR]);
        }
      })
      .catch((error) => {
        let localErr = errorMessagesFromRedux || [];
        if (error?.response?.status === 400) {
          const errMsg =
            error?.response?.data?.message || error?.message || GENERIC_ERR;
          localErr = localErr.filter((item) => item.field !== 'resultNotFound');
          localErr.push({
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: errMsg,
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'resultNotFound');
          localErr.push({
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: GENERIC_ERR,
          });
        }
        dispatch(handleErrorMessages([...new Set(localErr)]));
      });
  };

  const [fieldErr, setFieldErr] = useState({
    endQtrErr: false,
    overlapErr: false,
    singleCdReqErr: false,
  });

  const deleteDrug = (selectedRowLine) => {
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter((item) => item.field !== 'resultNotFound');
    if (selectedRowLine?.data?.addNewRow) {
      const rowIndex = resultData?.findIndex((x) => {
        return x.id === selectedRowLine?.data?.id;
      });
      localErr = localErr?.filter((item) =>
        item.fieldName?.includes(`on Row #${rowIndex}`)
      );
      const newObj = [...resultData];
      newObj.splice(rowIndex, 1);
      dispatch(setNewCmsMatRowData(newObj));
      if (
        !(
          newObj?.filter((x) => {
            return x.addEdit;
          })?.length > 0
        )
      ) {
        setStateChange('edit', false);
      }
    } else {
      validateDeleteDrug(selectedRowLine);
      handleScrollToEvent();
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
    setSuccessMessages([]);
  };

  const handleClearFilter = () => {
    childRef?.current?.clearFilters && childRef.current.clearFilters();
    setFilterRest(false);
  };
  useEffect(() => {
    if (filterRest) {
      searchCmsMatDrugList();
      handleClearFilter();
      setFilterRest(false);
    }
  }, [filterRest]);

  useEffect(() => {
    setSuccessMessages([]);
    if (editedData && editedData.length === 0) {
      searchCmsMatDrugList();
    }
  }, []);

  const addCMSMatDrug = (e, data, tbl) => {
    if (validateRequest(tbl)) {
      let localErr = errorMessagesFromRedux || [];
      localErr = localErr?.filter((item) => item.field !== 'resultNotFound');
      dispatch(handleErrorMessages([...new Set(localErr)]));
      setAdd(true);
      setSuccessMessages([]);
      const blankObj = {
        id: uuidv4(),
        cmsMATSeqNum: null,
        disableEndQtr: null,
        disableGenCodeNum: null,
        disableSpecTheraCode: null,
        disableStartQtr: null,
        endQtr: null,
        genCodeNum: '',
        isRemovedFromList: false,
        addEdit: true,
        addNewRow: true,
        rowId: null,
        specTheraCode: null,
        startQtr: '',
        index: 0,
      };
      dispatch(addNewRowData(blankObj, tbl));
      if (data) {
        let newData = [...data];
        newData.push(blankObj);
        dispatch(dispatchGetCMSTableEditedData(newData));
      } else editedData.push(blankObj);
      setStateChange('edit', true);
    }
  };

  const handleViewHistory = (gridAPI) => {
    const selectedRow1 = gridAPI.getSelectedRows()?.[0]?.cmsMATSeqNum;
    if (selectedRow1 !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ MAT_SEQ_NUM: selectedRow1 });
    }
  };

  useEffect(() => {}, [viewHistoryListData]);
  const gridHeight = fullScreenView ? '70vh' : 360;

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };
  const frameworkComponents = {
    StartQtrTextbox: (cellInfo) => (
      <TextBoxRender
        label="Start Quarter"
        id={`startQtr_${cellInfo ? cellInfo.rowIndex : 'unknownIndex'}`}
        ariaLabel="Start Quarter"
        isEnablebyRole={isEnablebyRole}
        {...cellInfo}
      />
    ),
    EndQtrTextbox: (cellInfo) => (
      <TextBoxRender
        label="End Quarter"
        id={`endQtr_${cellInfo ? cellInfo.rowIndex : 'unknownIndex'}`}
        ariaLabel="End Quarter"
        isEnablebyRole={isEnablebyRole}
        {...cellInfo}
      />
    ),
    SpecTheraTextbox: (cellInfo) => (
      <CmsFrameworks
        label="Spec Thera"
        id={`specThera_${cellInfo ? cellInfo.rowIndex : 'unknownIndex'}`}
        ariaLabel="Spec Thera"
        isEnablebyRole={isEnablebyRole}
        {...cellInfo}
      />
    ),
    GenericCodeTextBox: (cellInfo) => (
      <CmsFrameworks
        label="CMS"
        id={`cms_${cellInfo ? cellInfo.rowIndex : 'unknownIndex'}`}
        ariaLabel="CMS"
        isEnablebyRole={isEnablebyRole}
        addAction={addCMSMatDrug}
        {...cellInfo}
      />
    ),
    DeleteActionRender: (cellInfo) => {
      return (
        <div
          className="tdCell icon-btn-group"
          tabIndex={0}
          aria-label="Delete Action"
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="delete-tooltip">Delete</Tooltip>}
          >
            <Button
              data-testid="deleteBtn"
              className="th-ic trash-blue"
              variant="text"
              disabled={cellInfo.data.permanentDelete || isEnablebyRole}
              onClick={() => {
                setOpenDelete(true);
                setSelectedRows(cellInfo);
              }}
              aria-label="Delete"
              tabIndex={0}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </div>
      );
    },
  };

  // Ag-grid
  return (
    <div className="tabs-container">
      <div className="tBillPanel custom-check">
        <div className="paneldevider-line">
          <Spinner load={spinnerLoader} />
          <SaveCancelPopup
            open={open}
            title="Save"
            onConfim={() => {
              setWillClostTab(false);

              masterDataSave();
            }}
            onCancel={() => {
              handleSaveClose();
            }}
          />
          <SaveCancelPopup
            open={openCancel}
            title="Cancel"
            onConfim={() => {
              handleCancel();
            }}
            onCancel={() => {
              handleCancelClose();
            }}
          />
          <SaveCancelPopup
            open={openDelete}
            title="Delete"
            moduleName="the selected record"
            onConfim={() => {
              setOpenDelete(false);
              deleteDrug(selectedRows);
            }}
            onCancel={() => {
              setOpenDelete(false);
            }}
          />
          <div>
            <CustomSeparator parent1="CMS" parent2="Maintain CMS MAT Drugs" />
          </div>
          <div>
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesFromRedux.length > 0
                    ? _.map(errorMessagesFromRedux, (l) => l.message)
                    : []
                ),
              ]}
            />
            <DisplaySuccessMessages successMessages={successMessages} />
            {!fullScreenView && (
              <div className="flex-block justify-end pb-1">
                <div className="btn-wrapper float-right">
                  <Button
                    className="btn btn-success btn-save"
                    onClick={openSave}
                    data-testid="openSave"
                    disabled={!edit || isEnablebyRole}
                  >
                    <SVGComponent iconName="Icon-awesome-save" />
                    Save
                  </Button>
                  <Button
                    className="btn btn-cancel"
                    data-testid="open_Cancel"
                    onClick={() => cancel()}
                    disabled={!edit || isEnablebyRole}
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <div className="clearfix" />
          <TableGrid
            gridHeight={fullScreenView ? '100vh' : 350}
            rowData={
              resultData?.filter((x) => {
                return !x.isRemovedFromList;
              }) || []
            }
            onCellValueChanged={onEditingStopped}
            columnDefs={cmsTableHead}
            data-testid="onEditingStopped"
            //enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenViewClick}
            exportFile
            fileName="Maintain CMS MAT Drugs"
            frameworkComponents={frameworkComponents}
            addTxt="Add CMS MAT DRUG"
            addAction={addCMSMatDrug}
            handleViewHistory={handleViewHistory}
            disableAddAction={isEnablebyRole}
          />
        </div>
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="CMS_64_MAT"
            keyValue={keyValue}
          />
        )}
      </div>
    </div>
  );
}
export default withRouter(MatDrug);
